import React from "react";
import { ContextAppData, ContextTypes } from "./interfaces";

export const Context = React.createContext<ContextTypes>({} as ContextTypes);

export const contextInitialState: ContextAppData = {
  showDesktopMenu: true,
  selectedAccessPointGuard: "",
};

interface ContextProviderProps {
  children: JSX.Element | JSX.Element[];
}

export const ContextProvider = ({ children }: ContextProviderProps) => {
  const [showDesktopMenu, setShowDesktopMenu] = React.useState<boolean>(
    contextInitialState.showDesktopMenu
  );
  const [selectedAccessPointGuard, setSelectedAccessPointGuard] =
    React.useState<string>(contextInitialState.selectedAccessPointGuard);

  return (
    <Context.Provider
      value={{
        showDesktopMenu,
        setShowDesktopMenu,
        selectedAccessPointGuard,
        setSelectedAccessPointGuard,
      }}
    >
      {children}
    </Context.Provider>
  );
};
